import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, Alert, Button } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { handleSendOtp, handleAddSMS, reset, updateAuth } from '../user.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { CHANGE_PHONE, SUCCESS, ERROR, NUMBER_OTP_FAIL, MESSAGE, Authenticator_Type } from 'app/config/constants';
import OtpInput from 'react-otp-input';
import MessageModal from 'app/shared/message/message-modal';
import { generateCaptcha } from '../../password-reset/password-reset.reducer';
import AlertMessage from 'app/view-common/AlertMessage';
import { reSendOtp } from 'app/modules/sendOtp/sendOtp.reducer';

export interface IAuthEditProps extends StateProps, DispatchProps {
  id: any;
  value: any;
  modalShow: boolean;
  handleClose: Function;
}

export interface IAuthEditState {
  visible: boolean;
  color: string;
  message: string;
  otp: string;
  showFormOTP: boolean;
  phone: string;
  showMessage: boolean;
  typeReSend: boolean;
  messageSuccess: string;
  typeMessage: string;
  captcha: string;
  showMessageError: boolean;
  messageError: string;
  timeLeft: number;
  timerOn: boolean;
}

export class AuthEdit extends React.Component<IAuthEditProps, IAuthEditState> {
  timerID = null;
  state: IAuthEditState = {
    visible: false,
    color: 'info',
    message: '',
    otp: '',
    showFormOTP: false,
    phone: '',
    showMessage: false,
    typeReSend: false,
    messageSuccess: '',
    typeMessage: SUCCESS,
    captcha: '',
    showMessageError: false,
    messageError: '',
    timeLeft: 0,
    timerOn: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.resUpdateAuth !== nextProps.resUpdateAuth) {
      const { resUpdateAuth } = nextProps;
      if (resUpdateAuth && resUpdateAuth.status === 'KEY_NOT_CORRECT') {
        let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
        count = count + 1;
        Storage.session.set('count', count);
        this.setState({
          visible: true,
          color: 'danger',
          message: resUpdateAuth.message,
          otp: ''
        });
      } else if (resUpdateAuth && resUpdateAuth.status === 'SUCCESS') {
        this.setState({
          showFormOTP: false,
          otp: ''
        });
        this.props.handleClose();
      } else if (resUpdateAuth && resUpdateAuth.status) {
        this.setState({
          color: 'danger',
          message: resUpdateAuth.message,
          visible: true
        });
      }
    }

    if (this.props.resSendOtp !== nextProps.resSendOtp) {
      const { responseReSend } = nextProps;
      if (responseReSend && responseReSend.status === 'SUCCESS') {
        Storage.session.remove('count');
        let { id } = this.props;
        this.setState({
          visible: true,
          color: 'success',
          message:
            id.indexOf('@') > 0 ? translate('sendOtp.messages.sendotpSuccessTypeEmail') : translate('sendOtp.messages.sendotpSuccess'),
          otp: ''
        });
      } else if (responseReSend && responseReSend.status) {
        this.props.generateCaptcha();
        this.setState({
          color: 'danger',
          message: responseReSend.message,
          visible: true
        });
      }
      this.props.generateCaptcha();
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }
  componentDidMount(): void {
    this.props.generateCaptcha();
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  handleSubmitInput = (event, values) => {
    this.setState({ phone: values.mobile.trim(), showFormOTP: true });
    const type = values.mobile.indexOf('@') > 0 ? 'EMAIL' : 'SMS';
    this.props.reSendOtp(this.state.phone, type, MESSAGE.OTP);
    // this.props.handleSendOtp(this.state.phone, CHANGE_PHONE, '');
  };

  handleValidSubmit = () => {
    const type = this.props.value.indexOf('@') > 0 ? Authenticator_Type.EMAIL : Authenticator_Type.SMS;
    this.props.updateAuth(this.state.phone, this.props.value, type, this.state.otp);
  };

  onDismiss = () => {
    this.setState({ visible: false, showMessageError: false, messageError: '' });
  };

  closeModal = () => {
    this.setState({ showMessageError: false, messageError: '', typeReSend: false });
    this.props.handleClose();
  };

  handleReSendOtp = () => {
    this.props.reSendOtp(this.state.phone, 'EMAIL', MESSAGE.OTP);

    this.setState({
      timerOn: true,
      timeLeft: 120
    });
  };

  tick = () => {
    if (this.state.timerOn && this.state.timeLeft > 0) {
      this.setState({ timeLeft: this.state.timeLeft - 1 });
    } else {
      this.setState({ timerOn: false });
    }
  };

  renderFormInput = () => {
    return (
      <Row className="justify-content-center bodyModal">
        <Col md="12">
          <h5 className="text-center txtContent">{this.props.value.indexOf('@') > 0 ? 'Nhập email' : 'Nhập số điện thoại'}</h5>
          <Alert color="danger" isOpen={this.state.showMessageError} toggle={this.onDismiss}>
            {this.state.messageError}
          </Alert>
          <AvForm id="register-form" onValidSubmit={this.handleSubmitInput}>
            {this.props.value.indexOf('@') > 0 ? (
              <AvField
                name="mobile"
                placeholder="Nhập Email"
                validate={{
                  required: { value: true, errorMessage: translate('register.messages.validate.email.required') },
                  email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
                }}
              />
            ) : (
              <AvField
                name="mobile"
                placeholder="Nhập Số điện thoại"
                validate={{
                  required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                  number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') }
                }}
              />
            )}

            <Button className="btn-register" type="submit" block>
              Cập nhật
            </Button>
          </AvForm>
        </Col>
      </Row>
    );
  };

  renderFormOTP = () => {
    let phone = this.state.phone;
    if (phone) {
      phone = phone.startsWith('84') ? phone.replace('84', '0') : phone;
      phone = phone.slice(0, 3) + '****' + phone.slice(7, phone.length);
    }
    return (
      <Row className="justify-content-center bodyModal">
        {window['inputNumber']()}
        <Col md="12">
          <h2 className="text-center font-weight-bold" id="password-title">
            <Translate contentKey="sendOtp.title">Nhập mã OTP</Translate>
          </h2>
          <h6 className="text-center txtContent font-weight-bold">
            <Translate contentKey="sendOtp.txtContent1" interpolate={{ email: phone }}>
              Otp code has been sent via phone number: {phone}
            </Translate>
          </h6>

          <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
            {this.state.message}
          </Alert>

          <AvForm className="text-center" id="password-form" onValidSubmit={this.handleValidSubmit}>
            <p className="text-center">Nhập mã OTP</p>
            <div id="inputOtp">
              <OtpInput
                inputStyle={{
                  width: '2.5rem',
                  height: '2.5rem',
                  margin: '5px 5px',
                  fontSize: '1.5rem',
                  borderRadius: 4,
                  border: '1px solid rgba(0,0,0,0.3)'
                }}
                numInputs={6}
                onChange={otp => this.setState({ otp })}
                value={this.state.otp}
              />
            </div>

            <p className="text-center">
              Bạn chưa nhận được mã?
              <Button className="btnLink" color="link" style={{ color: '#4D9235' }} type="button" onClick={this.handleReSendOtp}>
                Gửi lại OTP
              </Button>
            </p>

            <Button className="btn-register" type="submit" block>
              <Translate contentKey="sendOtp.form.button">Confirm</Translate>
            </Button>
          </AvForm>
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <div>
        <MessageModal type={this.state.typeMessage} showModal={this.state.showMessage} message={this.state.messageSuccess} />
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.closeModal}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.closeModal} />
          <ModalBody className="padding-modal-body">{!this.state.showFormOTP ? this.renderFormInput() : this.renderFormOTP()}</ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resSendOtp: storeState.userInfo.resSendOtp,
  response: storeState.userInfo.responseAddSMS,
  responseCap: storeState.passwordReset.responseCaptcha,
  resUpdateAuth: storeState.userInfo.resUpdateAuth,
  responseReSend: storeState.sendotp.responseReSend
});

const mapDispatchToProps = { reSendOtp, reset, generateCaptcha, updateAuth };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthEdit);
